var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFBD00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,17.6h-2.4c1.7-1.8,2.7-4.3,2.7-7c0-0.8-0.1-1.6-0.3-2.3l0,0.1c-0.9-3.4-3.6-6.1-7.1-6.7l-0.1,0 c-0.4-0.1-0.9-0.1-1.4-0.1c-3.8,0-7.1,2-8.9,5.1l0,0L32,16.5l-6.8-9.8c-1.8-3.1-5.1-5.1-8.9-5.1c-0.5,0-1,0-1.4,0.1l0.1,0 C11.4,2.3,8.6,5,7.8,8.3l0,0.1c-0.2,0.7-0.2,1.5-0.2,2.3c0,2.7,1,5.1,2.7,7l0,0H7.8c-3.1,0-5.5,2.5-5.5,5.5v6c0,2.5,1.7,4.6,4,5.3 l0,0v20.9c0,3.1,2.5,5.5,5.5,5.5h40.3c3.1,0,5.5-2.5,5.5-5.5V34.5c2.3-0.7,4-2.8,4-5.3v-6C61.7,20.1,59.2,17.6,56.2,17.6L56.2,17.6 L56.2,17.6z M41.3,8.4c1.3-2.3,3.7-3.8,6.5-3.8c0.3,0,0.5,0,0.8,0l0,0c2.3,0.5,4.2,2.2,4.7,4.4l0,0c0.1,0.4,0.1,0.8,0.1,1.3 c0,3-1.5,5.7-3.8,7.2l0,0H34.9L41.3,8.4z M10.7,9.1c0.6-2.3,2.4-4,4.7-4.5l0,0c0.2,0,0.5,0,0.8,0c2.8,0,5.2,1.5,6.5,3.8l0,0l6.4,9.2 H14.5c-2.3-1.6-3.9-4.2-3.9-7.2C10.6,9.9,10.6,9.5,10.7,9.1L10.7,9.1L10.7,9.1z M5.3,29.2v-6c0-1.4,1.1-2.5,2.5-2.5h22.7v11.1H7.8 C6.4,31.7,5.3,30.6,5.3,29.2L5.3,29.2z M9.3,55.4V34.8h21.2v23.2H11.9C10.5,57.9,9.3,56.8,9.3,55.4L9.3,55.4z M54.7,55.4 c0,1.4-1.1,2.5-2.5,2.5H33.5V34.8h21.2V55.4z M58.7,29.2c0,1.4-1.1,2.5-2.5,2.5H33.5V20.7h22.7c1.4,0,2.5,1.1,2.5,2.5l0,0V29.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.937665c594126367aa9254d8bbfe66c3.svg";
export { ForwardRef as ReactComponent };